import React from 'react';

function Samoa(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_123957)">
        <mask
          id="mask0_800_123957"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_123957)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V24H36V0H0Z"
            fill="#C51918"
          />
          <mask
            id="mask1_800_123957"
               style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="36"
            height="24"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V24H36V0H0Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_800_123957)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0 0V14H18V0H0Z"
              fill="#2E42A5"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M4.0113 7.77201L2.81875 8.41196L3.09076 7.16317L2.09766 6.22857L3.44238 6.17803L4.0113 5.01196L4.58022 6.17803H5.92266L4.93184 7.16317L5.23013 8.41196L4.0113 7.77201Z"
              fill="#FEFFFF"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M13.0113 7.77201L11.8187 8.41196L12.0908 7.16317L11.0977 6.22857L12.4424 6.17803L13.0113 5.01196L13.5802 6.17803H14.9227L13.9318 7.16317L14.2301 8.41196L13.0113 7.77201Z"
              fill="#FEFFFF"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M8.39873 4.13798L7.27633 4.74028L7.53234 3.56495L6.59766 2.68532L7.86327 2.63776L8.39873 1.54028L8.93419 2.63776H10.1977L9.26512 3.56495L9.54587 4.74028L8.39873 4.13798Z"
              fill="#FEFFFF"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M9.61444 8.42526L8.91294 8.8017L9.07295 8.06711L8.48877 7.51735L9.27978 7.48762L9.61444 6.8017L9.9491 7.48762H10.7388L10.1559 8.06711L10.3314 8.8017L9.61444 8.42526Z"
              fill="#FEFFFF"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M8.33492 12.8283L6.65131 13.7318L7.03533 11.9688L5.6333 10.6493L7.53173 10.578L8.33492 8.93176L9.1381 10.578H11.0333L9.6345 11.9688L10.0556 13.7318L8.33492 12.8283Z"
              fill="#FEFFFF"
            />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_123957">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Samoa;
